<template>
  <div>
    <c-card-group columns class="card-columns cols-2">
      <c-card>
        <c-card-header>
          Line Chart
          <div class="card-header-actions">
            <a
              href="https://coreui.io/vue/docs/components/charts"
              class="card-header-action"
              rel="noreferrer noopener"
              target="_blank"
            >
              <small class="text-muted">docs</small>
            </a>
          </div>
        </c-card-header>
        <c-card-body>
          <c-chart-line-example />
        </c-card-body>
      </c-card>
      <c-card>
        <c-card-header>Bar Chart</c-card-header>
        <c-card-body><c-chart-bar-example /></c-card-body>
      </c-card>
      <c-card>
        <c-card-header>Doughnut Chart</c-card-header>
        <c-card-body><c-chart-doughnut-example /></c-card-body>
      </c-card>
      <c-card>
        <c-card-header>Radar Chart</c-card-header>
        <c-card-body><c-chart-radar-example /></c-card-body>
      </c-card>
      <c-card>
        <c-card-header>Pie Chart</c-card-header>
        <c-card-body><c-chart-pie-example /></c-card-body>
      </c-card>
      <c-card>
        <c-card-header>Polar Area Chart</c-card-header>
        <c-card-body><c-chart-polar-area-example /></c-card-body>
      </c-card>
      <c-card>
        <c-card-header>Simple line chart</c-card-header>
        <c-card-body>
          <c-chart-line-simple border-color="success" labels="months" />
        </c-card-body>
      </c-card>
      <c-card>
        <c-card-header>Simple pointed chart</c-card-header>
        <c-card-body><c-chart-line-simple pointed border-color="warning" /></c-card-body>
      </c-card>
      <c-card>
        <c-card-header>Simple bar chart</c-card-header>
        <c-card-body><c-chart-bar-simple background-color="danger" /></c-card-body>
      </c-card>
    </c-card-group>
  </div>
</template>

<script>
import * as Charts from './index.js';

export default {
  name: 'Charts',
  components: {
    ...Charts,
  },
};
</script>
